export enum Flag {
    Afghanistan = 'af',
    Angola = 'ao',
    Albania = 'al',
    Andorra = 'ad',
    UnitedArabEmirates = 'ae',
    Argentina = 'ar',
    Armenia = 'am',
    AntiguaAndBarbuda = 'ag',
    Australia = 'au',
    Austria = 'at',
    Azerbaijan = 'az',
    Burundi = 'bi',
    Belgium = 'be',
    Benin = 'bj',
    BurkinaFaso = 'bf',
    Bangladesh = 'bd',
    Bulgaria = 'bg',
    Bahrain = 'bh',
    Bahamas = 'bs',
    BosniaAndHerzegovina = 'ba',
    Belarus = 'by',
    Belize = 'bz',
    Bolivia = 'bo',
    Brazil = 'br',
    Barbados = 'bb',
    BruneiDarussalam = 'bn',
    Bhutan = 'bt',
    Botswana = 'bw',
    CentralAfricanRepublic = 'cf',
    Canada = 'ca',
    Switzerland = 'ch',
    Chile = 'cl',
    China = 'cn',
    CoteDIvoire = 'ci',
    Cameroon = 'cm',
    DemocraticRepublicOfTheCongo = 'cd',
    RepublicOfTheCongo = 'cg',
    Colombia = 'co',
    Comoros = 'km',
    CapeVerde = 'cv',
    CostaRica = 'cr',
    Cuba = 'cu',
    Cyprus = 'cy',
    CzechRepublic = 'cz',
    Germany = 'de',
    Djibouti = 'dj',
    Dominica = 'dm',
    Denmark = 'dk',
    DominicanRepublic = 'do',
    Algeria = 'dz',
    Ecuador = 'ec',
    Egypt = 'eg',
    Eritrea = 'er',
    Spain = 'es',
    Estonia = 'ee',
    Ethiopia = 'et',
    Finland = 'fi',
    Fiji = 'fj',
    France = 'fr',
    MicronesiaFederatedStatesOf = 'fm',
    Gabon = 'ga',
    UnitedKingdom = 'gb',
    Georgia = 'ge',
    Ghana = 'gh',
    Guinea = 'gn',
    Gambia = 'gm',
    GuineaBissau = 'gw',
    EquatorialGuinea = 'gq',
    Greece = 'gr',
    Grenada = 'gd',
    Guatemala = 'gt',
    Guyana = 'gy',
    Honduras = 'hn',
    Croatia = 'hr',
    Haiti = 'ht',
    Hungary = 'hu',
    Indonesia = 'id',
    India = 'in',
    Ireland = 'ie',
    IranIslamicRepublicOf = 'ir',
    Iraq = 'iq',
    Iceland = 'is',
    Israel = 'il',
    Italy = 'it',
    Jamaica = 'jm',
    Jordan = 'jo',
    Japan = 'jp',
    Kazakhstan = 'kz',
    Kenya = 'ke',
    Kyrgyzstan = 'kg',
    Cambodia = 'kh',
    Kiribati = 'ki',
    SaintKittsAndNevis = 'kn',
    SouthKorea = 'kr',
    Kuwait = 'kw',
    LaoPeopleSDemocraticRepublic = 'la',
    Lebanon = 'lb',
    Liberia = 'lr',
    Libya = 'ly',
    SaintLucia = 'lc',
    Liechtenstein = 'li',
    SriLanka = 'lk',
    Lesotho = 'ls',
    Lithuania = 'lt',
    Luxembourg = 'lu',
    Latvia = 'lv',
    Morocco = 'ma',
    Monaco = 'mc',
    Moldova = 'md',
    Madagascar = 'mg',
    Maldives = 'mv',
    Mexico = 'mx',
    MarshallIslands = 'mh',
    NorthMacedonia = 'mk',
    Mali = 'ml',
    Malta = 'mt',
    Myanmar = 'mm',
    Montenegro = 'me',
    Mongolia = 'mn',
    Mozambique = 'mz',
    Mauritania = 'mr',
    Mauritius = 'mu',
    Malawi = 'mw',
    Malaysia = 'my',
    Namibia = 'na',
    Niger = 'ne',
    Nigeria = 'ng',
    Nicaragua = 'ni',
    Netherlands = 'nl',
    Norway = 'no',
    Nepal = 'np',
    Nauru = 'nr',
    NewZealand = 'nz',
    Oman = 'om',
    Pakistan = 'pk',
    Panama = 'pa',
    Peru = 'pe',
    Philippines = 'ph',
    Palau = 'pw',
    PapuaNewGuinea = 'pg',
    Poland = 'pl',
    FrenchPolynesia = 'pf',
    NorthKorea = 'kp',
    Portugal = 'pt',
    Paraguay = 'py',
    Qatar = 'qa',
    Romania = 'ro',
    Russia = 'ru',
    Rwanda = 'rw',
    SaudiArabia = 'sa',
    Sudan = 'sd',
    Senegal = 'sn',
    Singapore = 'sg',
    SolomonIslands = 'sb',
    SierraLeone = 'sl',
    ElSalvador = 'sv',
    SanMarino = 'sm',
    Somalia = 'so',
    Serbia = 'rs',
    SouthSudan = 'ss',
    SaoTomeAndPrincipe = 'st',
    Suriname = 'sr',
    Slovakia = 'sk',
    Slovenia = 'si',
    Sweden = 'se',
    Eswatini = 'sz',
    Seychelles = 'sc',
    Syria = 'sy',
    Chad = 'td',
    Togo = 'tg',
    Thailand = 'th',
    Tajikistan = 'tj',
    Turkmenistan = 'tm',
    TimorLeste = 'tl',
    Tonga = 'to',
    TrinidadAndTobago = 'tt',
    Tunisia = 'tn',
    Turkey = 'tr',
    Tuvalu = 'tv',
    Tanzania = 'tz',
    Uganda = 'ug',
    Ukraine = 'ua',
    Uruguay = 'uy',
    UnitedStates = 'us',
    Uzbekistan = 'uz',
    VaticanCity = 'va',
    SaintVincentAndTheGrenadines = 'vc',
    Venezuela = 've',
    Vietnam = 'vn',
    Vanuatu = 'vu',
    Samoa = 'ws',
    Yemen = 'ye',
    SouthAfrica = 'za',
    Zambia = 'zm',
    Zimbabwe = 'zw',
}